'use client';

import { useEffect } from 'react';

export function ViewportHeightFix() {
    useEffect(() => {
        const set = () => {
            document.documentElement.style.setProperty('--app-height', `${window.innerHeight}px`);
        };
        set();
        window.addEventListener('resize', set);
        return () => window.removeEventListener('resize', set);
    }, []);
    return null;
}
